// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "37b70a03a06fbbf0ef21cd65e278d4b9" + ".js";
};